<!-- This component displays a disabled button with the number  of pdfs referenced within a news item-->
<!-- Prerequisite: newsItem has a ._pdfs attribute storing the referenced Pdfs-->
<template>
  <v-tooltip v-if="newsItem._pdfs && newsItem._pdfs.length > 0" bottom min-width="200">
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <v-btn small depressed >
          <v-icon small left>mdi-paperclip</v-icon>
          {{ newsItem._pdfs.length }}
        </v-btn>
      </div>
    </template>

    <span> {{ $t('news.contains') }} {{ newsItem._pdfs.length }} {{ newsItem._pdfs.length > 1 ? $t('news.pdfs') : $t('news.pdf') }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    newsItem: {
      type: Object,
    },
  },
};
</script>

<style></style>
